import constantFactory from "@gaoding/constant-factory";

export const {
  RESOLUTION,
  RESOLUTION_LIST,
  RESOLUTION_MAP,
  RESOLUTION_ITEM_MAP,
} = constantFactory("RESOLUTION", [
  {
    key: "tiny",
    label: "小图",
    optionLabel: "小图 1～480px",
    value: "tiny",
  },
  {
    key: "small",
    label: "中图",
    optionLabel: "中图 480～720px",
    value: "small",
  },
  {
    key: "medium",
    label: "大图",
    optionLabel: "大图 720～1080px",
    value: "medium",
  },
  {
    key: "large",
    label: "特大图",
    optionLabel: "特大图 1080～1440px",
    value: "large",
  },
  {
    key: "huge",
    label: "超大图",
    optionLabel: "超大图 1440px+",
    value: "huge",
  },
]);
